export const joinProcessCropTypeConstants = {
  key: '재배작물',
  values: ['수도작', '밭작물', '과수원', '하우스', '축산', '조사료'],
  labels: [
    '논에서 벼 재배 등',
    '콩, 고추, 배추 등',
    '사과, 배, 포도 등',
    '딸기, 토마토 등',
    '가축 사육과 관리',
    '목초, 옥수수 등',
  ],
};
